var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.changelog)?_c('div',{staticClass:"pt-5 d-flex justify-content-center"},[_c('b-card',{staticClass:"p-3 w-100",staticStyle:{"max-width":"768px"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.changelog)}})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }